<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="RedPackLog.beanList" row-key="opTime">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="用户Id" min-width="120" align="center" prop="userId"/>
                <el-table-column label="用户昵称" min-width="120" align="center" prop="userName"/>
                <el-table-column label="中奖的级别" min-width="120" align="center" prop="level"/>
                <el-table-column label="中得金额" min-width="150" align="center" prop="num"/>
                <el-table-column label="注入时间" width="150" align="center" prop="createdTime">
                  <template slot-scope="scope">{{scope.row.createdTime|getLocalTime}}</template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="RedPackLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('market', ['RedPackLog'])
        },
        methods: {
            ...mapActions('market', ['getRedPackLog']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getRedPackLog(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>
